import React, { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';

import { useColors } from '../../hooks';

const CarouselIndicator = ({ itemCount, currentIndex }) => {
  const colors = useColors();
  const indicators = useMemo(() => new Array(itemCount).fill(0), [itemCount]);

  return (
    <View style={styles.container}>
      {indicators.map((_, i) => {
        return (
          <View
            key={i}
            style={[
              styles.indicator,
              i === currentIndex
                ? { backgroundColor: colors.primary }
                : { backgroundColor: colors.borderColor },
            ]}
          />
        );
      })}
    </View>
  );
};

export default React.memo(CarouselIndicator);

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    alignSelf: 'center',
    marginVertical: 20,
  },
  indicator: {
    width: 8,
    height: 8,
    borderRadius: 3,
    marginRight: 8,
  },
});
